import {
  EscalationService,
  MfaOrchestratorService,
  MfaPushService,
  OauthService,
  OpenAPI,
  OtpService,
  PendingAuthService,
} from '@/api/generated';
import { getAppVersion } from '@/config/env-config';
import { getTabId } from '@/utils/tab-id';

const getApiBaseUrl = () => {
  if (typeof window !== 'undefined') {
    return `${window.location.origin}/auth`;
  }

  return '/auth';
};

const BASE_API_URL = getApiBaseUrl();

OpenAPI.BASE = BASE_API_URL;
OpenAPI.WITH_CREDENTIALS = true;
OpenAPI.CREDENTIALS = 'include';
// Configure OpenAPI to include tab ID header for request correlation
OpenAPI.HEADERS = async (): Promise<Record<string, string>> => ({
  'x-tab-id': getTabId(),
  'x-client-version': getAppVersion(),
});

console.info('API Base URL:', OpenAPI.BASE);

export const mfaOrchestrationService = MfaOrchestratorService;
export const mfaPushNotificationsService = MfaPushService;
export const otpService = OtpService;
export const pendingAuthService = PendingAuthService;
export const escalationService = EscalationService;
export const oauthService = OauthService;
